import { TableHeadersType } from "../../constant/tableHeadersConstants/tableHeadersType";
import { tableEditIcon } from "../../assets/images";
import { formatDate, formateDateWithTime } from "../../utils/commonFunctions";
import { LoginResponseType } from "../../redux/auth/authTypes";
import { CircularAvatar } from "../commons";
import { AuditSessionListType } from "../../redux/fixedAsset/fixedAssetRegisterTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import UpdatedByAndUpdatedAt from "../commons/CommonUpdatedByAndUpdatedAt";
type AppProps = {
  tableHeaders: TableHeadersType[] | [];
  data: AuditSessionListType[] | [];
  history: any;
  loginData: LoginResponseType;
};
const AuditSessionTableData = ({
  tableHeaders,
  data,
  loginData,
  history,
}: AppProps) => {
  const client_code =
    history && history?.location && history?.location.state?.client_code
      ? history?.location.state?.client_code
      : "";
  const company_name =
    history &&
    history.location &&
    history.location.state &&
    history.location.state.company_name
      ? history.location.state.company_name
      : "";
  return (
    <>
      {data?.length > 0 &&
        data?.map((auditData: any) => {
          let parsedProfilePic = auditData?.updated_by_details?.profile_pic
            ? JSON.parse(auditData?.updated_by_details?.profile_pic)?.file_url
            : "";

          return (
            <tr className="text-left">
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: TableHeadersType) => {
                  if (header?.value == "start_date") {
                    return (
                      <td className="text-left">
                        {auditData?.start_date
                          ? formatDate(auditData?.start_date)
                          : ""}
                      </td>
                    );
                  } else if (header?.value == "end_date") {
                    return (
                      <td className="text-left">
                        {auditData?.end_date
                          ? formatDate(auditData?.end_date)
                          : ""}
                      </td>
                    );
                  } else if (header?.value == "financial_year") {
                    return (
                      <td className="text-left">{auditData?.financial_year}</td>
                    );
                  } else if (header?.value == "user_details") {
                    return (
                      <td className="text-start" style={{ minWidth: "200px" }}>
                        {auditData?.user_details?.map((e: any) => (
                          <>
                            <div className="d-flex justify-content-sm-start mb-1 ml-2">
                              <CircularAvatar
                                name={e?.first_name}
                                image={e?.profile_pic?.file_url}
                              />
                              <span
                                style={{ marginLeft: "10px", marginTop: "2px" }}
                              >
                                {e?.first_name} {e?.last_name}
                              </span>
                            </div>
                          </>
                        ))}
                      </td>
                    );
                  } else if (header?.value === "updated_by") {
                    return (
                      <td className="text-start" style={{ minWidth: "180px" }}>
                        <UpdatedByAndUpdatedAt
                          firstName={auditData?.updated_by_details?.first_name}
                          lastName={auditData?.updated_by_details?.last_name}
                          profilePic={parsedProfilePic ? parsedProfilePic : ""}
                          updatedAt={formateDateWithTime(auditData?.updated_at)}
                        />
                      </td>
                    );
                  } else if (header?.value == "action") {
                    return (
                      <td style={{ width: "50px", textAlign: "start" }}>
                        <span
                          className="d-inline-block pointer"
                          onClick={() => {
                            history?.push({
                              pathname: `/fixed-asset-register/audit-session/${client_code}/edit/${auditData?.id}`,
                              state: {
                                client_code: client_code,
                                company_name,
                                audit_session_id: auditData?.id,
                                data: auditData,
                              },
                            });
                          }}
                        >
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                            }}
                          >
                            <OverlayTrigger
                              placement="top"
                              delay={{ show: 250, hide: 250 }}
                              overlay={
                                <Tooltip id="button-view-open-item">
                                  Edit
                                </Tooltip>
                              }
                            >
                              <img src={tableEditIcon} alt="" />
                            </OverlayTrigger>
                          </div>
                        </span>
                      </td>
                    );
                  }
                  return null;
                })}
            </tr>
          );
        })}
    </>
  );
};

export default AuditSessionTableData;
